import Quill, { Delta } from "quill";
import { IAnchor } from "./DocumentComments/useCommentsContext";

export const applyCommentFormatting = (
  quillRef:React.RefObject<{ getQuill: () => Quill | null }>,
  anchor:IAnchor,
  id?:number,
  source:any = Quill.sources.SILENT
) => {
  const quill = quillRef.current?.getQuill();
  if (!quill || !anchor) return;
  quill.formatText(anchor.o, anchor.l, 'comment', id || false, source);
}

export const clearQuillInstance = (
  quillRef:React.RefObject<{ getQuill: () => Quill | null }>
):Quill | null => {
  const quill = quillRef.current?.getQuill();
  if (!quill) return null;
  const module = quill.getModule('table-better') as any;
  module.deleteTableTemporary();
  module.hideTools();
  module.clearHistorySelected();
  return quill;
}

export const transformRange = (
  range: IAnchor | null,
  delta: Delta,
  priority = false
): IAnchor | null => {
  if (!range) return null;

  const newIndex = delta.transformPosition(range.o, priority);
  const newEnd = delta.transformPosition(range.o + range.l, priority);

  return {
    o: newIndex,
    l: Math.max(0, newEnd - newIndex) // clamp so no negatives
  };
}
